import { CustomFieldsForm } from "./CustomFieldsForm"

interface Props {
  close: () => void
}

export const CustomFieldsCreationForm = ({ close }: Props) => {
  return <CustomFieldsForm close={close} />
}
